import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import { toast } from "react-toastify";
import { RESET_PASSWORD } from "../../../services/ApiCalls";

const ResetPassword = () => {
  const [passVisible, setPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // Quien llega aca por el link del correo es un paciente/terapeuta (usa la
  // app movil, no este panel) - mandarlo a /login (el login de admin/staff)
  // solo confundia, ya que nunca va a poder entrar ahi. En vez de navegar,
  // mostramos una pantalla de exito que le dice que vuelva a la app.
  const [submitted, setSubmitted] = useState(false);
  const { id } = useParams();


  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Minimum length validation
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    if (formData.confirmPassword.length < 6) {
      toast.error("Confirm Password must be at least 6 characters long");
      return;
    }

    // Match validation
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const response = await RESET_PASSWORD(  {
          email: formData.email,
          password: formData.password,
          confirmPassword: formData.confirmPassword,
          passwordToken:id
        })
        if(response.data.status!=="failure"){
      toast.success("Password reset successfully");
      setSubmitted(true);}
      else{
        toast.error(response.data.message)

      }
    } catch (error) {
      alert(
        error.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="formInner position-relative px-lg-3">
        <div className="w-100 inner text-center py-4">
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: "#e6f4ea",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 6L9 17l-5-5"
                stroke="#2e7d32"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h4 className="fw-sbold themeClr">Password Changed</h4>
          <p className="mt-2 mb-0" style={{ color: "#6c757d" }}>
            You can close this window now and log in again from the
            Blossom app with your new password.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="formInner position-relative px-lg-3">
      <div className="w-100 inner">
        <div className="top py-2">
          <div className="d-flex align-items-center gap-10">
            <Link
              to="/forgot-password"
              className="d-inline-flex align-items-center justify-content-center border py-2 btn"
            >
              Back
            </Link>
            <h4 className="m-0 fw-sbold themeClr">Reset Password</h4>
          </div>
        </div>

        <Form
          className={`${styles.form} pt-lg-4 pt-2`}
          onSubmit={handleSubmit}
        >
          <Row className="justify-content-center">

            {/* Email */}
            <Col lg="12" className="my-2">
              <label className="form-label pb-1 themeClr fw-sbold">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`${styles.formControl} form-control`}
                placeholder="johndoe@gmail.com"
                required
              />
            </Col>

            {/* New Password */}
            <Col lg="12" className="my-2">
              <label className="form-label pb-1 themeClr fw-sbold">
                New Password
              </label>
              <div className="position-relative">
                <input
                  type={passVisible ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`${styles.formControl} form-control`}
                  placeholder="*************"
                  required
                />
                <Button
                  type="button"
                  onClick={() => setPassVisible(!passVisible)}
                  className="border-0 p-0 position-absolute"
                  style={{ right: 10, top: 8 }}
                  variant="transparent"
                >
                  👁
                </Button>
              </div>
            </Col>

            {/* Confirm Password */}
            <Col lg="12" className="my-2">
              <label className="form-label pb-1 themeClr fw-sbold">
                Confirm Password
              </label>
              <div className="position-relative">
                <input
                  type={confirmPassVisible ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={`${styles.formControl} form-control`}
                  placeholder="*************"
                  required
                />
                <Button
                  type="button"
                  onClick={() =>
                    setConfirmPassVisible(!confirmPassVisible)
                  }
                  className="border-0 p-0 position-absolute"
                  style={{ right: 10, top: 8 }}
                  variant="transparent"
                >
                  👁
                </Button>
              </div>
            </Col>

            {/* Submit */}
            <Col lg="8" className="my-2">
              <div className={`${styles.btnWrpper} pt-3`}>
                <Button
                  type="submit"
                  disabled={
                    loading 
                   
                  }
                  className="w-100 commonBtn"
                >
                  {loading ? "Please wait..." : "Submit"}
                </Button>
              </div>
            </Col>

          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;